import script from "./TheTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTabs.vue?vue&type=script&setup=true&lang=js"

import "./TheTabs.vue?vue&type=style&index=0&id=1545bfa7&lang=css"

const __exports__ = script;

export default __exports__